module.exports = __webpack_public_path__ + "static/media/the-new-jim-crow.3e11b436.jpg";